<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Retenciones
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(style="border-radius:5px;background-color: white;")
          v-card-title(style='padding: 8px !important;').justify-center
            img(src='../assets/logo.png', style='height: auto;width: 140px;')
        v-card(style="border-radius:5px;background-color: black")
          v-card-title(style="padding: 7px;").justify-center
            span.white--text Administración de Retenciones

    //- Modal para ver comprobante ampliado
    v-dialog(v-model='dialogImg', max-width='920px')
      v-card(style="background-color: white;")
        v-card-title(style="background: #111; color: white; padding: 12px 18px;")
          span Comprobante de Retención - {{ itemSel ? itemSel.nro_retencion : '' }}
          v-spacer
          v-btn(icon dark @click='dialogImg = false')
            v-icon mdi-close
        v-card-text(style="padding: 16px;")
          div(v-if="itemSel && itemSel.comprobante")
            div(v-if="itemSel.comprobante.toLowerCase().endsWith('.pdf')")
              div(style="display: flex; justify-content: flex-end; align-items: center; gap: 8px; margin-bottom: 12px; flex-wrap: wrap;")
                v-btn(small outline :color="visorPdfModo === 'google' ? 'primary' : 'grey'" @click="visorPdfModo = 'google'")
                  v-icon(left small) preview
                  | Visor Web
                v-btn(small outline :color="visorPdfModo === 'nativo' ? 'primary' : 'grey'" @click="visorPdfModo = 'nativo'")
                  v-icon(left small) picture_as_pdf
                  | Visor Directo
                v-btn(small flat color="primary" :href="urlPdfDirecta" target="_blank")
                  v-icon(left small) open_in_new
                  | Abrir en Pestaña

              iframe(:src="urlPdfActual" style="width: 100%; height: 75vh; border: 1px solid #e2e8f0; border-radius: 8px; background: #f8fafc;")
            div.text-xs-center(v-else)
              a(:href="ruta + itemSel.comprobante" target="_blank" title="Abrir en pestaña nueva")
                img(:src="ruta + itemSel.comprobante", style="max-width: 100%; max-height: 75vh; object-fit: contain; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.15);")
              div(style="margin-top: 10px;")
                a(:href="ruta + itemSel.comprobante" target="_blank" style="color: #0872E9; text-decoration: none; font-weight: 600;")
                  v-icon(small color="primary") open_in_new
                  |  Abrir imagen en tamaño completo
          div.text-xs-center(v-else style="padding: 40px; color: #888;")
            v-icon(size="48" color="grey") mdi-image-off
            div No posee comprobante adjunto

    //- Modal de detalle y acciones
    v-dialog(v-model='dialogDetalle', persistent max-width='700px')
      v-card(style='background-color:white !important;')
        v-card-title.justify-center(style="background: black; color: white; padding: 10px;")
          span.headline(style="font-size: 18px !important;") Solicitud de Retención # {{ form.nro }}
        v-card-text(style="padding: 20px;")
          v-layout(row wrap)
            v-flex(xs12 sm6)
              v-text-field(outline readonly v-model="form.nro_retencion" label="N° de Retención:" prepend-inner-icon="tag")
            v-flex(xs12 sm6)
              v-text-field(outline readonly v-model="form.montoDisplay" label="Monto Retenido:" prepend-inner-icon="attach_money")
            v-flex(xs12 sm6)
              v-text-field(outline readonly v-model="form.clienteNombre" label="Cliente:" prepend-inner-icon="business")
            v-flex(xs12 sm6)
              v-text-field(outline readonly v-model="form.clienteRif" label="RIF Cliente:" prepend-inner-icon="badge")
            v-flex(xs12 sm6)
              v-text-field(outline readonly v-model="form.vendedorNombre" label="Vendedor:" prepend-inner-icon="person")
            v-flex(xs12 sm6)
              v-text-field(outline readonly v-model="form.fechaFormateada" label="Fecha de Registro:" prepend-inner-icon="event")
            v-flex(xs12)
              v-text-field(outline readonly v-model="form.estatus" label="Estatus actual:" prepend-inner-icon="info")
            v-flex(xs12 v-if="form.observacion")
              v-textarea(outline readonly v-model="form.observacion" :label="form.estatus === 'Rechazado' ? 'Motivo del Rechazo:' : 'Observación:'" prepend-inner-icon="notes" rows="2")

            //- Tabla de facturas afectadas si existen
            v-flex(xs12 v-if="form.facturas && form.facturas.length > 0" style="margin-top: 10px;")
              div(style="font-weight: bold; font-size: 13px; color: #1e293b; margin-bottom: 8px;") Facturas Afectadas ({{ form.facturas.length }}):
              v-data-table(:headers="headersFacturas" :items="form.facturas" hide-actions class="elevation-1" style="border-radius: 8px; overflow: hidden;")
                template(v-slot:items="p")
                  td.text-xs-center(style="font-weight: bold; color: #0284c7;") {{ p.item.nro_factura }}
                  td.text-xs-center {{ p.item.nro_control || '-' }}
                  td.text-xs-center {{ p.item.fecha || '-' }}
                  td.text-xs-center(style="font-weight: 500;") Bs. {{ formatoMonto(p.item.base_imponible) }}
                  td.text-xs-center(style="font-weight: 500;") Bs. {{ formatoMonto(p.item.impuesto_iva) }}
                  td.text-xs-center(style="font-weight: bold; color: #10b981;") Bs. {{ formatoMonto(p.item.iva_retenido) }}

            //- Comprobante miniatura en el modal
            v-flex(xs12 v-if="form.comprobante" style="display: flex; justify-content: center; margin: 15px 0 10px 0;")
              div(style="text-align: center;")
                div(style="font-weight: 600; margin-bottom: 6px; font-size: 12px; color: #666;") COMPROBANTE ADJUNTO (Click para ampliar):
                div(v-if="form.comprobante.toLowerCase().endsWith('.pdf')" @click="verImagen(form)" style="display: inline-flex; align-items: center; gap: 8px; padding: 12px 20px; border-radius: 8px; background: #fff1f2; border: 1px solid #fecdd3; cursor: pointer;")
                  v-icon(color="red" size="32") picture_as_pdf
                  span(style="font-weight: bold; color: #9f1239;") Ver Documento PDF
                img(v-else :src="ruta + form.comprobante" @click="verImagen(form)" style="max-height: 220px; max-width: 100%; object-fit: contain; cursor: pointer; border-radius: 6px; border: 1px solid #ddd;")

        v-card-actions(style="padding: 16px; background: #f8f9fa;")
          v-spacer
          v-btn(v-if="form.estatus === 'Pendiente'" color="success" style="border-radius: 8px;" @click="cambiarEstatus(form, 'Aprobado')")
            v-icon(left) check_circle
            | Aprobar
          v-btn(v-if="form.estatus === 'Pendiente'" color="error" style="border-radius: 8px;" @click="cambiarEstatus(form, 'Rechazado')")
            v-icon(left) cancel
            | Rechazar
          v-btn(style="background: black; color: white; border-radius: 8px;" @click="dialogDetalle = false")
            | Cerrar

    //- Filtros y Barra superior
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12 style='margin-top: 5px;')
        v-layout(wrap style='justify-content: space-between; align-items: center; padding: 0 10px;')
          v-flex(xs12 sm3)
            v-text-field(v-model='search', label='Buscar cliente, vendedor o N° retención', prepend-inner-icon="search" clearable)
          v-flex(xs12 sm3 style='padding-left:15px;')
            v-select(:items='filtrosEstatus' v-model="filtroEstatus" label="Estatus" @change='cargarRetenciones()')
          v-flex(xs12 sm3 style='padding-left:15px;')
            v-menu(ref='menuFecha' v-model='menuFecha' :close-on-content-click='false' transition='scale-transition' offset-y max-width='320px')
              template(v-slot:activator='{ on }')
                v-text-field(v-model='fechaRangoTexto' label='Rango de Fechas' prepend-inner-icon="date_range" readonly v-on='on' clearable @click:clear="limpiarFechas")
              v-date-picker(range v-model='fechas' no-title)
                v-spacer
                v-btn(text color='primary' @click='menuFecha = false; cargarRetenciones()') OK
          v-flex(xs12 sm3 style='display: flex; justify-content: flex-end; align-items: center;')
            v-btn(color="primary" dark style="border-radius: 8px;" @click="cargarRetenciones" :loading="loading")
              v-icon(left) refresh
              | Actualizar

        //- Cabecera y Tabla
        v-card(style="border-radius: 0px 0px 20px 20px; background-color: black; margin-top: 10px;")
          v-card-title(style="padding: 7px;").justify-center
            span.white--text Listado de Retenciones

        v-data-table.elevation-1(
          :headers='headers'
          :items='retenciones'
          :loading='loading'
          :search='search'
          :pagination.sync="pagination"
          style="margin-top: 5px;"
          no-data-text="No se encontraron retenciones"
        )
          template(slot='items', slot-scope='props')
            td.text-xs-center {{ props.item.nro }}
            td.text-xs-center {{ formatearFecha(props.item.fechaC) }}
            td
              div(style="font-weight: 600; color: #1e293b;") {{ props.item.cliente ? props.item.cliente.cli_des : 'N/A' }}
              div(style="font-size: 11px; color: #64748b;") {{ props.item.cliente ? props.item.cliente.rif : '' }} ({{ props.item.cliente ? props.item.cliente.co_cli : '' }})
            td.text-xs-center {{ props.item.ven_des || props.item.vendedor || 'N/A' }}
            td.text-xs-center
              span(style="font-weight: bold; color: #0284c7;") {{ props.item.nro_retencion }}
            td.text-xs-center
              span(style="font-weight: bold; color: #10b981;") ${{ formatoMonto(props.item.monto) }}
            td.text-xs-center
              v-tooltip(bottom v-if="props.item.observacion")
                template(v-slot:activator='{ on }')
                  v-chip(
                    small
                    :color="colorEstatus(props.item.estatus)"
                    text-color="white"
                    style="font-weight: 600; font-size: 11px; cursor: pointer;"
                    v-on="on"
                  ) {{ props.item.estatus }}
                span {{ props.item.estatus === 'Rechazado' ? 'Motivo: ' + props.item.observacion : props.item.observacion }}
              v-chip(
                v-else
                small
                :color="colorEstatus(props.item.estatus)"
                text-color="white"
                style="font-weight: 600; font-size: 11px;"
              ) {{ props.item.estatus }}
            td.text-xs-center
              div(v-if="props.item.comprobante")
                v-btn(icon small @click="verImagen(props.item)" title="Ver comprobante")
                  v-icon(color="red" v-if="props.item.comprobante.toLowerCase().endsWith('.pdf')") picture_as_pdf
                  v-icon(color="primary" v-else) image
              div(v-else style="color: #aaa; font-size: 11px;") Sin imagen
            td.text-xs-center
              v-layout(row justify-center)
                v-tooltip(bottom)
                  template(v-slot:activator='{ on }')
                    v-icon.mr-2(color='blue' @click='verDetalle(props.item)' v-on="on" style="cursor: pointer;") visibility
                  span Ver detalle
                v-tooltip(bottom v-if="props.item.estatus === 'Pendiente'")
                  template(v-slot:activator='{ on }')
                    v-icon.mr-2(color='green' @click='cambiarEstatus(props.item, "Aprobado")' v-on="on" style="cursor: pointer;") check_circle
                  span Aprobar
                v-tooltip(bottom v-if="props.item.estatus === 'Pendiente'")
                  template(v-slot:activator='{ on }')
                    v-icon(color='red' @click='cambiarEstatus(props.item, "Rechazado")' v-on="on" style="cursor: pointer;") cancel
                  span Rechazar
</template>

<script>
import Api from "@/services/methods";
import { serverImg, server } from "@/services/environment";
import moment from "moment";

export default {
  name: "Retenciones",
  data: () => ({
    ruta: serverImg,
    serverUrl: server,
    visorPdfModo: "google",
    retenciones: [],
    loading: false,
    search: "",
    filtroEstatus: "Todos",
    fechas: [],
    menuFecha: false,
    dialogImg: false,
    dialogDetalle: false,
    itemSel: null,
    pagination: {
      rowsPerPage: 25,
      sortBy: "nro",
      descending: true
    },
    form: {
      nro: "",
      nro_retencion: "",
      montoDisplay: "",
      clienteNombre: "",
      clienteRif: "",
      vendedorNombre: "",
      fechaFormateada: "",
      estatus: "",
      observacion: "",
      comprobante: ""
    },
    filtrosEstatus: [
      { text: "Todos", value: "Todos" },
      { text: "Pendientes", value: "Pendiente" },
      { text: "Aprobados", value: "Aprobado" },
      { text: "Rechazados", value: "Rechazado" }
    ],
    headers: [
      { text: "Nro", value: "nro", align: "center", sortable: true },
      { text: "Fecha", value: "fechaC", align: "center", sortable: true },
      { text: "Cliente", value: "cliente.cli_des", align: "left", sortable: true },
      { text: "Vendedor", value: "ven_des", align: "center", sortable: true },
      { text: "N° Retención", value: "nro_retencion", align: "center", sortable: true },
      { text: "Monto", value: "monto", align: "center", sortable: true },
      { text: "Estatus", value: "estatus", align: "center", sortable: true },
      { text: "Comprobante", value: "comprobante", align: "center", sortable: false },
      { text: "Acciones", value: "acciones", align: "center", sortable: false }
    ],
    headersFacturas: [
      { text: "Factura", value: "nro_factura", align: "center", sortable: false },
      { text: "Control", value: "nro_control", align: "center", sortable: false },
      { text: "Fecha", value: "fecha", align: "center", sortable: false },
      { text: "Base Imponible", value: "base_imponible", align: "center", sortable: false },
      { text: "Impuesto IVA", value: "impuesto_iva", align: "center", sortable: false },
      { text: "IVA Retenido", value: "iva_retenido", align: "center", sortable: false }
    ]
  }),
  computed: {
    fechaRangoTexto() {
      if (!this.fechas || this.fechas.length === 0) return "";
      if (this.fechas.length === 1) return this.fechas[0];
      return `${this.fechas[0]} ~ ${this.fechas[1]}`;
    },
    urlPdfDirecta() {
      if (!this.itemSel || !this.itemSel.comprobante) return "";
      if (this.itemSel._id) {
        return `${this.serverUrl}/api/retenciones/pdf/${this.itemSel._id}`;
      }
      return this.ruta + this.itemSel.comprobante;
    },
    urlPdfActual() {
      if (!this.itemSel || !this.itemSel.comprobante) return "";
      const directUrl = this.ruta + this.itemSel.comprobante;
      if (this.visorPdfModo === "nativo") {
        if (this.itemSel._id) {
          return `${this.serverUrl}/api/retenciones/pdf/${this.itemSel._id}`;
        }
        return directUrl;
      }
      return `https://docs.google.com/viewer?url=${encodeURIComponent(directUrl)}&embedded=true`;
    }
  },
  mounted() {
    this.cargarRetenciones();
  },
  methods: {
    cargarRetenciones() {
      this.loading = true;
      let url = "retenciones?limit=200";
      if (this.filtroEstatus && this.filtroEstatus !== "Todos") {
        url += `&estatus=${this.filtroEstatus}`;
      }
      if (this.fechas && this.fechas.length > 0) {
        url += `&fechaDesde=${this.fechas[0]}`;
        if (this.fechas.length > 1) {
          url += `&fechaHasta=${this.fechas[1]}`;
        }
      }

      Api.get(url)
        .then(res => {
          this.loading = false;
          if (res && res.data) {
            this.retenciones = res.data.data || res.data;
          } else if (Array.isArray(res)) {
            this.retenciones = res;
          } else {
            this.retenciones = [];
          }
        })
        .catch(err => {
          this.loading = false;
          console.error("Error al cargar retenciones:", err);
          this.$swal({
            type: "error",
            title: "Error",
            text: "No se pudieron obtener las retenciones."
          });
        });
    },

    limpiarFechas() {
      this.fechas = [];
      this.cargarRetenciones();
    },

    formatearFecha(f) {
      if (!f) return "N/A";
      return moment(f).format("DD/MM/YYYY hh:mm A");
    },

    formatoMonto(m) {
      if (m == null || isNaN(m)) return "0.00";
      return parseFloat(m).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },

    colorEstatus(estatus) {
      if (estatus === "Aprobado") return "green";
      if (estatus === "Rechazado") return "red";
      return "orange";
    },

    verImagen(item) {
      this.itemSel = item;
      this.dialogImg = true;
    },

    verDetalle(item) {
      this.form = {
        ...item,
        montoDisplay: `$${this.formatoMonto(item.monto)}`,
        clienteNombre: item.cliente ? item.cliente.cli_des : "N/A",
        clienteRif: item.cliente ? item.cliente.rif : "N/A",
        vendedorNombre: item.ven_des || item.vendedor || "N/A",
        fechaFormateada: this.formatearFecha(item.fechaC)
      };
      this.dialogDetalle = true;
    },

    cambiarEstatus(item, nuevoEstatus) {
      if (nuevoEstatus === "Rechazado") {
        this.$swal.fire({
          title: "Motivo del rechazo",
          text: `Retención N°: ${item.nro_retencion || item.nro} - Monto: $${this.formatoMonto(item.monto)}`,
          input: "text",
          inputPlaceholder: "Ingrese el motivo del rechazo...",
          inputAttributes: {
            autocapitalize: "off"
          },
          showCancelButton: true,
          confirmButtonColor: "#F44336",
          confirmButtonText: "Rechazar",
          cancelButtonText: "Cancelar",
          reverseButtons: true
        }).then(result => {
          if (result.dismiss) {
            // Cancelado por el usuario
          } else if (result.value && result.value.trim().length > 0) {
            const observacion = result.value.trim();
            this.loading = true;
            const payload = {
              estatus: "Rechazado",
              observacion: observacion,
              usuario: this.$store.state.adminfercoven ? this.$store.state.adminfercoven._id : null,
              accion: `Modificación de estatus (Rechazado), Retención N°: ${item.nro_retencion || item.nro}`
            };

            Api.put(`retenciones/${item._id}`, payload)
              .then(() => {
                this.loading = false;
                this.dialogDetalle = false;
                this.$swal.fire(
                  "¡Retención Rechazada!",
                  "Modificación realizada exitosamente.",
                  "success"
                );
                this.cargarRetenciones();
              })
              .catch(err => {
                this.loading = false;
                console.error("Error al rechazar retención:", err);
                this.$swal.fire(
                  "Oops...",
                  "Error encontrado, verifique los datos o llame al administrador.",
                  "error"
                );
              });
          } else {
            this.$swal.fire(
              "¡Atención!",
              "Debe ingresar el motivo del rechazo.",
              "error"
            );
          }
        });
      } else {
        this.$swal.fire({
          title: "¿Desea aprobar la retención?",
          text: `N° Retención: ${item.nro_retencion || item.nro} - Monto: $${this.formatoMonto(item.monto)}`,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#4CAF50",
          cancelButtonColor: "#333",
          confirmButtonText: "Sí, aprobar",
          cancelButtonText: "Cancelar",
          reverseButtons: true
        }).then(result => {
          if (result.value) {
            this.loading = true;
            const payload = {
              estatus: "Aprobado",
              usuario: this.$store.state.adminfercoven ? this.$store.state.adminfercoven._id : null,
              accion: `Modificación de estatus (Aprobado), Retención N°: ${item.nro_retencion || item.nro}`
            };

            Api.put(`retenciones/${item._id}`, payload)
              .then(() => {
                this.loading = false;
                this.dialogDetalle = false;
                this.$swal.fire(
                  "¡Retención Aprobada!",
                  "Modificación realizada exitosamente.",
                  "success"
                );
                this.cargarRetenciones();
              })
              .catch(err => {
                this.loading = false;
                console.error("Error al aprobar retención:", err);
                this.$swal.fire(
                  "Oops...",
                  "Error encontrado, verifique los datos o llame al administrador.",
                  "error"
                );
              });
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.withTd2 {
  padding: 8px !important;
  border: 1px solid #e2e8f0;
}
</style>
